/**
 * Stop Status Icon Generator
 * Main function for generating HTML strings for stop status icons
 * Fully implements the original Greenmile.Utils.getStopStatusIcon logic
 */

import {
  extractStopData,
  getStopType,
  getNextStopProjectedArrivalTime,
  createAllIconConfigurations,
  getCorrectIcon
} from './stopStatusUtils.js';

/**
 * Generates HTML string for stop status icon
 * Maintains full compatibility with original Greenmile.Utils.getStopStatusIcon function
 * Handles all stop statuses: redelivery, cancel, undeliverable, pending, completed, in_progress,
 * partially_delivered, wait, overnight, break, paid_wait, paid_break, paid_overnight, depot
 *
 * @param {Object} stop - Stop data object (Backbone model or plain object)
 * @returns {string} HTML string for the stop status icon
 */
export const getStopStatusIcon = (stop) => {
  try {
    const stopData = extractStopData(stop);
    const stopType = getStopType(stopData);
    const nextStopProjectedArrivalTime = getNextStopProjectedArrivalTime(stopData, stopType);
    const iconConfigurations = createAllIconConfigurations(stopData, nextStopProjectedArrivalTime);
    const correctIcon = getCorrectIcon(stopData, iconConfigurations, stopType);

    return correctIcon;
  } catch (error) {
    console.error('Error generating stop status icon:', error);

    const fallbackTitle = 'Greenmile.Stop.IconDescription.pending';
    return `<div class='stopIconCollection'>
              <div class='stopIcon stopPending' title='${fallbackTitle}'></div>
            </div>`;
  }
};

export default getStopStatusIcon;
